import './Canvas.css'
import React, {EventHandler, SyntheticEvent, useEffect, useRef} from 'react'
import { kvObj } from '../kvObj';

interface CanvasProps {
    map: kvObj;
    grassy: boolean;
    map_click: Function;
}

interface Coords {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    angle?: number;
    code: string;
}

interface Spot {
    code: string;
    x: number;
    y: number;
    height: number;
    angle?: number;
    optional?: boolean;
}

const spots: Spot[] = [
  { code: 'O1', x: 0.555, y: 2, height: 60, optional:true },
  { code: 'O2', x:.137, y: 2, height: 60, optional:true },
  { code: 'O3', x: 0.555, y: 58, height: 60,  optional:true },  
  { code: 'O4', x:.137, y: 58, height: 60,  optional:true },
  { code: 'O6', x:.137, y: 114, height: 60, optional:true },
  { code: '36', x:.137, y: 170, height: 60 },
  { code: '34', x:.137, y: 228, height: 60 },
  { code: '32', x:.137, y: 282, height: 60 },
  { code: '30', x:.137, y: 336, height: 60 },
  { code: '28', x:.137, y: 390, height: 60 },
  { code: '26', x:.137, y: 444, height: 60 },
  { code: '24', x:.137, y: 498, height: 60 },
  { code: '22', x:.137, y: 552, height: 60 },
  { code: '35', x: 0.555, y: 170, height: 60 },
  { code: '33', x: 0.555, y: 228, height: 60 },
  { code: '31', x: 0.555, y: 282, height: 60 },
  { code: '29', x: 0.555, y: 336, height: 60 },
  { code: '27', x: 0.555, y: 390, height: 60 },
  { code: '25', x: 0.555, y: 444, height: 60 },
  { code: '23', x: 0.555, y: 498, height: 60 },
  { code: '21', x: 0.555, y: 552, height: 60 },
  { code: '2', x:.137, y: 737, height: 68.5 },
  { code: '4', x:.137, y: 805, height: 68 },
  { code: '6', x:.137, y: 873, height: 68 },
  { code: '8', x:.137, y: 941, height: 68 },
  { code: '10', x:.137, y: 1009, height: 68 },
  { code: '12', x:.137, y: 1077, height: 68 },
  { code: '14', x:.137, y: 1145, height: 68 },
  { code: '16', x:.137, y: 1213, height: 68 },
  { code: '18', x:.137, y: 1281, height: 68 },
  { code: '20', x:.137, y: 1349, height: 68 },
  { code: '1', x: 0.555, y: 737, height: 68 },
  { code: '3', x: 0.555, y: 805, height: 68 },
  { code: '5', x: 0.555, y: 873, height: 68 },
  { code: '7', x: 0.555, y: 941, height: 68 },
  { code: '9', x: 0.555, y: 1009, height: 68 },
  { code: '11', x: 0.555, y: 1077, height: 68 },
  { code: '13', x: 0.555, y: 1145, height: 68 },
  { code: '15', x: 0.555, y: 1213, height: 68 },
  { code: '17', x: 0.555, y: 1281, height: 68 },
  { code: '19', x: 0.555, y: 1349, height: 68 },
  { code: 'O7', x: 0.555, y: 1417, height: 68, optional: true },
{ code: 'O8', x: 0.137, y: 1417, height: 48, optional: true  },
{ code: 'O9', x: 0.559, y: 1505, height: 48, angle: -4, optional: true },
{ code: 'O10', x:.127, y: 1476, height: 48, angle: -4, optional: true },
{ code: 'O12', x:.100, y: 1528, height: 48, angle: -4, optional: true },
{ code: 'O14', x:.080, y: 1590, height: 48, angle: -4, optional: true },
{ code: 'G1', x: 0.075, y: 450, height: 60 },
{ code: 'G2', x: 0.075, y: 510, height: 60 },
{ code: 'G3', x: 0.075, y: 570, height: 60 },
{ code: 'G4', x: 0.075, y: 630, height: 60 },
{ code: 'G5', x: 0.075, y: 690, height: 60 },
{ code: 'G6', x: 0.075, y: 750, height: 60 },
{ code: 'G7', x: 0.075, y: 810, height: 60 },
{ code: 'G8', x: 0.075, y: 870, height: 60 },
{ code: 'G9', x: 0.075, y: 930, height: 60 },
{ code: 'G10', x: 0.075, y: 990, height: 60 },
{ code: 'G11', x: 0.075, y: 1050, height: 60 },
{ code: 'G12', x: 0.075, y: 1110, height: 60 }];


let assignments:  kvObj={}
let clickZones:Coords[]=[];
let grassy=false;
let mapClick:Function;

const handleclick: EventHandler<any>=(evt: SyntheticEvent) => {
  let e=evt.nativeEvent as PointerEvent;
  let x=e.offsetX;
  let y=e.offsetY
   const found=clickZones.filter(cz=> {  return (cz.x1<x && cz.x2>x && cz.y1<y && cz.y2>y)})
   mapClick(assignments[found[0].code])
}

const getLines: Function=( ctx: CanvasRenderingContext2D, text: string, width:number, height:number)=> {
   const Lines:string[]=[]
   const splitText=text.split(" ")
   let curline=""
   splitText.forEach(word=> {
      if (ctx.measureText(curline+" "+word).width>width) {
         Lines.push(curline);
         curline=word;
      }
      else {
        curline=curline+" "+word
      }
   })
   if (curline.length>0) {
     Lines.push(curline);
   }
   return Lines
}

const hasGrassys: Function=() => {
   let assigned:kvObj={}
   let grassy=false;
   let grassies=Object.keys(assignments).filter(k=> {return (k.indexOf("G")>-1)})
   return (grassies.length>0)
}

const drawColor: Function=(ctx: CanvasRenderingContext2D, categories: string, x:number, y: number, width: number, height:number, angle?: number, hasVendor?: boolean ) => {
  const cats=categories.split(",")//divide the category string into array elements (for case of comma separated)
  width=width/cats.length
  
  // Use darker gray for spots without vendors
  if (!hasVendor) {
    ctx.fillStyle = "#969696";
    if (angle) {
      ctx.save();
      const centerX = x + width * cats.length / 2;
      const centerY = y + height / 2;
      ctx.translate(centerX, centerY);
      ctx.rotate((angle * Math.PI) / 180);
      ctx.fillRect(-width * cats.length / 2, -height / 2, width * cats.length, height);
      ctx.restore();
    } else {
      ctx.fillRect(x, y, width * cats.length, height);
    }
    return;
  }
  
  if (angle) {
    ctx.save();
    const centerX = x + width * cats.length / 2;
    const centerY = y + height / 2;
    ctx.translate(centerX, centerY);
    ctx.rotate((angle * Math.PI) / 180);
    ctx.fillStyle=getComputedStyle(document.documentElement).getPropertyValue(`--map-color-${cats[0]}`)  || "#4c4545"
    ctx.fillRect(-width * cats.length / 2, -height / 2, width, height);
    if (cats.length>1) {
       ctx.fillStyle=getComputedStyle(document.documentElement).getPropertyValue(`--map-color-${cats[1].trim()}`)  || "#c7c7c7"
       ctx.fillRect(-width * cats.length / 2 + width, -height / 2, width, height);
    }
    ctx.restore();
  } else {
    ctx.fillStyle=getComputedStyle(document.documentElement).getPropertyValue(`--map-color-${cats[0]}`)  || "#4c4545"
    ctx.fillRect(x, y,width,height )
    if (cats.length>1) {
       ctx.fillStyle=getComputedStyle(document.documentElement).getPropertyValue(`--map-color-${cats[1].trim()}`)  || "#c7c7c7"
       ctx.fillRect(x+width, y,width,height )
    }
  }
}


const writeText: Function=(ctx: CanvasRenderingContext2D, text: string, x:number, y: number, width: number, height:number )=> {

}

const drawSpots: Function=(ctx: CanvasRenderingContext2D, innerWidth: number, grassy: boolean, yOffset: number = 0)=> {
  const width=innerWidth*.33 
  ctx.font=getComputedStyle(document.documentElement).getPropertyValue(`--map-text`) || "bold 14px Arial, sans-serif";
  ctx.fillStyle="black";
  ctx.textAlign="center";
  let spots_to_render=spots.filter(s=> {
    return ((grassy && s.x<.5) || (!grassy && (s.code.indexOf("G")==-1)))
  })
  clickZones=[]
  spots_to_render.forEach(spot=> {
    // Skip rendering spots without vendor assignments
    if (!assignments[spot.code]) {
      return;
    }
    
    let spot_x=!grassy?spot.x: (spot.code.indexOf("G")==-1?.55:spot.x)
    // Adjust y position based on offset
    let adjusted_y = spot.y - yOffset;
    
    const label=assignments[spot.code]?assignments[spot.code].name:"";
    const category=assignments[spot.code]?assignments[spot.code].categories:spot.code;
    const angle = spot.angle || 0;
    const hasVendor = !!assignments[spot.code];
    
    // Set stroke style based on vendor assignment
    ctx.strokeStyle = hasVendor ? "#000000" : "#cccccc";
    
    if (angle) {
      // Draw rotated rectangle
      ctx.save();
      const centerX = spot_x*innerWidth + width / 2;
      const centerY = adjusted_y + spot.height / 2;
      ctx.translate(centerX, centerY);
      ctx.rotate((angle * Math.PI) / 180);
      ctx.strokeRect(-width / 2, -spot.height / 2, width, spot.height);
      ctx.restore();
      
      // Draw rotated fill
      drawColor(ctx, category, spot_x*innerWidth, adjusted_y, width, spot.height, angle, hasVendor);
      
      // Draw rotated text
      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate((angle * Math.PI) / 180);
      ctx.fillStyle="white";
      const lines:string[]=getLines(ctx,label, width, spot.height);
      let texty=-spot.height/2+19;
      switch (lines.length){
          case 1: texty+=spot.height/4; 
                  break;
          case 2: texty+=spot.height/8; 
      }        
      ctx.fillStyle=getComputedStyle(document.documentElement).getPropertyValue(`--map-text-color-${category}`)
      lines.forEach(line=> {
        ctx.fillText(line, 0, texty, width)
        texty+=17;  
      })
      ctx.restore();
      
      // Store click zone (approximation - uses bounding box)
      clickZones.push({x1: spot_x*innerWidth, y1: adjusted_y, x2: spot_x*innerWidth+width, y2: adjusted_y+spot.height, angle: angle, code: spot.code});
    } else {
      // Draw normal rectangle
      ctx.strokeRect(spot_x*innerWidth, adjusted_y,width,spot.height )
      drawColor(ctx,category, spot_x*innerWidth, adjusted_y,width,spot.height, undefined, hasVendor )
      clickZones.push({x1: spot_x*innerWidth , y1: adjusted_y ,x2: spot_x*innerWidth+width, y2: adjusted_y+spot.height, code: spot.code })
      ctx.fillStyle="white";
      const lines:string[]=getLines(ctx,label, width, spot.height);
      let texty=adjusted_y+19;
      switch (lines.length){
          case 1: texty+=spot.height/4; 
                  break;
          case 2: texty+=spot.height/8; 
      }        
      ctx.fillStyle=getComputedStyle(document.documentElement).getPropertyValue(`--map-text-color-${category}`)
      lines.forEach(line=> {
        ctx.fillText(line,spot_x*innerWidth+(width/2), texty, width )
        texty+=17;  
      })
    }
   })
}

const Canvas =( { map, grassy, map_click}: CanvasProps) => {
   assignments=map
   mapClick=map_click  
   const canvasRef=useRef<HTMLCanvasElement>(null)   
   useEffect(()=> {
      if (canvasRef.current) {
        const canvas=canvasRef.current;
        const context=canvas.getContext('2d');
        const image=new Image();
        
        image.onload = () => {
            //canvas.style.position="absolute"
            let img_width=image.width;
            let img_height=image.height;
            let hw_ratio=img_height/img_width;
            let display_width=image.width
            let img_xoffset=0;
            const innerWidth=document.getElementsByClassName("ion-page")[0].clientWidth
            if (img_width>innerWidth ) {
              img_xoffset=grassy? 20 : image.width*.29           
              img_width=image.width*.66666
              display_width=innerWidth
            }     
            
            // Find the actual top and bottom vendor positions
            let minY = Infinity;
            let maxY = -Infinity;
            
            spots.forEach(spot => {
              if (assignments[spot.code] && spot.code.indexOf("G") === -1) { // Exclude grassy spots
                minY = Math.min(minY, spot.y);
                maxY = Math.max(maxY, spot.y + spot.height);
              }
            });
            
            // Calculate vertical offset and height adjustments
            let img_yoffset = 0;
            let adjusted_height = image.height;
            
            // If we found vendors, adjust to show only from first to last vendor
            if (minY !== Infinity && maxY !== -Infinity) {
              img_yoffset = Math.max(0, minY); // Start from the topmost vendor
              adjusted_height = maxY - img_yoffset + 10; // End at the bottommost vendor + 10px padding
            }
            
            //canvas.style.left=`-200px`        
            canvas.height=adjusted_height
            
            const scalex=(image.width-400)/innerWidth
            //console.log('innerwidth:', window.innerWidth, " imagewidth:", img_width, " xoffset",img_xoffset)
            context!.drawImage(image, img_xoffset, img_yoffset, img_width, adjusted_height, 0, 0, display_width, adjusted_height)
            drawSpots(context!, innerWidth, grassy, img_yoffset);
            //console.log(image.width, ",", image.height)
          };
        
        // Set src after onload handler is attached
        image.src="assets/map.svg"
      }
   })
   return <canvas ref={canvasRef} height={window.innerHeight} width={window.innerWidth} onClick={handleclick}/>   
}

export default Canvas